import { Close, DriveEta, Visibility } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  DialogContent,
  IconButton,
  Paper,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";
import { Form } from "formik";
import Calendar from "react-calendar";

export const StyledInput = {
  flex: 1,
  minWidth: 200,
  width: "100%",
  minWidth: "200px",
  "& .MuiInputAdornment-root": {
    marginRight: "8px",
  },
};
export const StyledProfessional = {
  flex: 1.5,
  marginRight: 5,
};
export const StyledCheckbox = {
  marginLeft: 5,
};

export const StyledAppointments = {
  RowContainer: styled("div")(({ theme }) => ({
    display: "flex",
    flex: 1,
    alignItems: "center",
    marginBottom: 10,
  })),
  LoadingContainer: styled(DialogContent)(({ theme }) => ({
    marginTop: 40,
    marginBottom: 80,
  })),
  FormControl: styled("div")(({ theme }) => ({
    margin: theme.spacing(1),
    minWidth: 250,
    marginLeft: 24,
  })),
  VisibilityIcon: styled(Visibility)(({ theme }) => ({
    cursor: "pointer",
  })),
  ActionsBox: styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
  })),
};

export const StyledAppointmentsDetail = {
  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),

  Title: styled(Typography)({
    color: "white",
    fontWeight: "bold",
    marginLeft: 10,
  }),

  AppointmentsContainer: styled(DialogContent)({
    display: "flex",
    padding: 0,
    backgroundColor: "#f5f5f5",
  }),
};

export const StyledAppointmentDetailsCard = {
  Container: styled("div")(({ theme }) => ({
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflow: "auto",
    padding: theme.spacing(1.25, 1.25, 1.25, 1.25),
  })),

  Card: styled(Paper)(({ theme }) => ({
    display: "flex",
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  })),

  AppointmentContainer: styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "65%",
  })),

  ActionsContainer: styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "35%",
  })),

  Button: styled("button")(({ theme }) => ({
    background: "transparent",
    border: "none",
    padding: 0,
    marginTop: theme.spacing(0.25),
  })),

  Icon: styled("div")(({ theme }) => ({
    cursor: "pointer",
  })),

  Tooltip: styled(Tooltip)(({ theme }) => ({
    cursor: "pointer",
    marginRight: theme.spacing(2),
  })),

  AppointmentDate: styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
  })),
};

export const StyledAppointmentDetailFromForm = {
  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),

  Title: styled(Typography)({
    color: "white",
    fontWeight: "bold",
    marginLeft: 10,
  }),

  CloseIcon: styled(Close)({
    color: "white",
    cursor: "pointer",
    width: 25,
    height: 25,
    position: "absolute",
    right: 0,
  }),

  TableContainer: styled("div")({
    overflow: "hidden",
    position: "relative",
  }),

  ScrollContainer: styled("div")({
    overflowY: "auto",
    overflowX: "hidden",
    height: "100%",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  }),

  ActionsContainer: styled("div")({
    display: "flex",
  }),
};

export const StyledAppointmetnsPrintSession = {
  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),
  Title: styled(Typography)(({ theme }) => ({
    color: "white",
    fontWeight: "bold",
    marginLeft: 10,
  })),
  AppointmentsContainer: styled(DialogContent)({
    padding: 0,
  }),
};

export const StyledAppointmentsSession = {
  Container: styled("div")({
    display: "flex",
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: "#f5f5f5",
    flexDirection: "column",
  }),

  AppointmentsContainer: styled("div")({
    display: "flex",
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 20,
  }),

  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 10,
    backgroundColor: theme.palette.primary.main,
  })),

  Title: styled(Typography)({
    color: "white",
    fontWeight: "bold",
    marginLeft: 10,
  }),

  Calendar: styled("div")({
    width: 1000,
    marginRight: 10,
    boxShadow: "1px 1px 7px rgba(219,219,219,1)",
    borderRadius: "5px",
  }),

  ActionsContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
    zIndex: 2,
    backgroundColor: "white",
    paddingRight: 10,
    boxShadow: "0px 0 5px lightGrey",
  }),

  Loading: styled("div")({
    marginTop: 60,
    marginBottom: 60,
  }),
};

export const StyledAppointmentsSessionCalendar = {
  Container: styled("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginRight: 20,
  }),
  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.secondary.dark,
    padding: 2,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  })),
  Title: styled(Typography)({
    color: "white",
    fontWeight: "bold",
  }),
  Calendar: styled(Calendar)({
    width: 400,
    boxShadow: "1px 1px 7px rgba(219,219,219,1)",
    borderRadius: "0px 0px 5px 5px",
  }),
};

export const StyledAppointmentsSessionCard = {
  Container: styled(Paper)(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    width: 270,
    height: 260,
    backgroundColor: "#f5f5f5",
  })),

  TitleContainer: styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.secondary.dark,
    padding: 2,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  })),

  Title: styled(Typography)({
    color: "white",
    fontWeight: "bold",
  }),

  AppointmentContainer: styled("div")({
    paddingTop: 10,
    overflow: "auto",
  }),

  Card: styled(Paper)({
    display: "flex",
    alignItems: "center",
    marginBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
  }),

  ContentContainer: styled("div")({
    display: "flex",
    flexDirection: "column",
    width: "80%",
  }),

  ActionsContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "20%",
  }),

  Button: styled("div")({
    cursor: "pointer",
    margin: 5,
  }),

  EmptyState: styled("div")({
    display: "flex",
    justifyContent: "center",
    marginTop: 60,
    marginBottom: 60,
  }),

  TimePickerStyled: styled(TimePicker)({
    width: 120,
  }),

  CarIcon: styled(DriveEta)(({ traslado }) => ({
    color: traslado ? "green" : "grey",
  })),
};

export const StyledAppointmentsSessionHeader = {
  Container: styled(Paper)({
    display: "flex",
    flexDirection: "column",
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 20,
    padding: 10,
    borderRadius: 5,
  }),

  Body: styled(Typography)({
    marginTop: 30,
  }),
};

export const StyledAppointmetnsTable = {
  ActionButton: styled("div")({
    width: "10px",
  }),

  DetailsTableContainer: styled("div")({
    backgroundColor: "#fafafa",
  }),

  ErrorChip: styled(Chip)({
    borderColor: "#f37c578f",
    color: "white",
    backgroundColor: "#FF9A78",
    fontFamily: "Roboto, sans-serif",
  }),

  SuccessChip: styled(Chip)({
    borderColor: "green",
    backgroundColor: "#00800094",
    color: "white",
    fontFamily: "Roboto, sans-serif",
  }),
};
export const StyledSearchContainer = {
  Container: styled("div")({
    marginBottom: "24px",
  }),
  Form: styled(Form)({
    width: "100%",
    display: "flex",
  }),
  Title: styled("div")({
    color: "#484848",
    marginBottom: "8px",
    fontFamily: "Roboto, sans-serif",
    fontSize: "large",
    fontWeight: 500,
  }),
};

export const StyledAppointmentsSearchForm = {
  StyledPaper: styled(Paper)({
    display: "flex",
    padding: 20,
    marginBottom: 20,
  }),
  StyledInput: styled("div")({
    display: "inline-flex",
    marginRight: 20,
    width: 250,
  }),
  ButtonContainer: styled("div")({
    display: "flex",
    justifyContent: "flex-end",
  }),

  StyledButton: styled(Button)(({ theme }) => ({
    margin: theme.spacing(1),
  })),
};

export const StyledAppointmentsTable = {
  ActionButton: styled(IconButton)(({ theme }) => ({
    width: "10px"
  })),
  Chip: styled(Chip)(({ theme, error }) => ({
    ...(!error ? {
      borderColor: "green",
      backgroundColor: "#00800094",
      color: "white",
      fontFamily: "Roboto, sans-serif",
    }
      : {
        borderColor: "#f37c578f",
        color: "white",
        backgroundColor: "#FF9A78",
        fontFamily: "Roboto, sans-serif",
      }
    )

  })),

};